export default __webpack_public_path__ + "static/media/queenatlantis2.f3ea488e.jpg";